<template>
  <div id="asset-details">
    <div class="breadcrumbs">
      <a href="/">Home</a> > <span v-html="salesModelLink"></span> > {{ flipAsset.title }}
    </div>
    <div v-if="flipAsset.salesState=='PendingPurchase'">
    <v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
    >This asset is pending sale, but you can find and invest in more like it on our <span v-html="salesModelLink"></span> page.</v-alert>
    </div>
    <div v-if="flipAsset.salesState=='Purchased'">
    <v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
    >This asset has been sold, but you can find and invest in more like it <a href="/flip">HERE</a></v-alert>
    </div>
    <v-row>
      <!-- left col -->
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        md="5"
      >
        <ImageBank></ImageBank>

      </v-col>

      <!-- right col -->
      <v-col md="7">
        <v-card
          flat
          tile
        >
          <v-card-title class="text-h4 justify-center justify-md-start px-0 pt-0">{{ flipAsset.title }}</v-card-title>

          <v-card-text class="px-0 pt-0">
            <!-- progress bar -->
            <v-progress-linear
              :value="funded"
              color="primary"
              height="25"
            >
              <template v-slot:default="{ value }">
                <strong>{{ value }}% Funded {{ flipAsset.salesState === 'Suspended' ? '(Funding Closed)' : ''}}</strong>
              </template>
            </v-progress-linear>



            <!-- mobile main image -->
            <v-col
              v-if="$vuetify.breakpoint.smAndDown"
              sd="12"
            >
              <v-img :src="mainImage.mediumUri"></v-img>
            </v-col>

            <!-- Asset Summary -->
            <v-card-subtitle class="text-h6 px-0 pb-0" v-if="flipAsset.metadata" v-html="flipAsset.metadata.summary"></v-card-subtitle>

            <SocialShareBar></SocialShareBar>

            <v-row>
              <!-- details list -->
              <v-col md="8" sd="12">
                <AssetDetailsList></AssetDetailsList>
              </v-col>

              <!-- desktop actions -->
              <v-col
                v-if="$vuetify.breakpoint.mdAndUp"
                md="4"
              >
                <AssetActions></AssetActions>
              </v-col>
            </v-row>

            <!-- Asset Description -->
            <div class="description" v-if="flipAsset.metadata" v-html="flipAsset.metadata.longDescription"></div>

            <!-- mobile gallery images -->
            <div
              v-if="$vuetify.breakpoint.smAndDown"
            >
              <v-col
                v-for="(image, i) in galleryImages"
                :key="i"
                sd="12"
              >
                <v-img :src="image.mediumUri" v-on:click="openLightboxOnSlide(i+2)"></v-img>
              </v-col>
              <FsLightbox
                :toggler="toggler"
                :slide="slide"
                :sources="lightboxImages"
                />
            </div>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- mobile actions -->
    <AssetMobileActions></AssetMobileActions>
  </div>
</template>

<script>
  import ImageBank from './ImageBank.vue'
  import AssetDetailsList from './AssetDetailsList.vue'
  import AssetActions from './AssetActions.vue'
  import AssetMobileActions from './AssetMobileActions.vue'
  import { mapGetters } from 'vuex'
  import FsLightbox from 'fslightbox-vue'
  import SocialShareBar from './SocialShareBar'

  export default {
    name: 'AssetDetails',

    components: {
      ImageBank,
      AssetDetailsList,
      AssetActions,
      AssetMobileActions,
      FsLightbox,
      SocialShareBar
    },

    data() {
      return {
        toggler: false,
        slide: 1
      }
    },

    created: function(){
      var currentUrl = window.location;
      console.log('meh ' + currentUrl);
    },

    methods: {
      openLightboxOnSlide: function(number) {
        this.slide = number;
        this.toggler = !this.toggler;
      }
    },

    computed: {
      ...mapGetters([
        'flipAsset'
      ]),
      salesModelLink: function() {
        if(this.flipAsset.salesModel) {
          return '<a href="/'+this.flipAsset.salesModel+'">'+this.flipAsset.salesModel.charAt(0).toUpperCase() + this.flipAsset.salesModel.slice(1)+'</a>';
        } else {
          return '';
        }
      },

      funded: function () {
        let fundedPerc = ((this.flipAsset.totalShares - this.flipAsset.sharesForSale) / this.flipAsset.totalShares) * 100

        //For release day traction
        if(this.flipAsset.id == 18) {
          fundedPerc = 100;
        }
        if(this.flipAsset.id == 24) {
          fundedPerc = 100;
        }

        //return Math.round(fundedPerc)
        return fundedPerc.toFixed(1)
      },
      // Process image array.
      mainImage: function () {
        return this.flipAsset.images.find(i=> i.type === 'mainImage')
      },
      galleryImages: function () {
        return this.flipAsset.images.filter(i => i.type === 'galleryImage')
      },
      lightboxImages: function () {
        if(typeof this.flipAsset.images !== 'undefined') {
          return this.flipAsset.images.map(i => i.largeUri)
        }
        return []
      }
    }
  }
</script>
